import FieldContainer from '@shared/components/core/field/FieldContainer';
import StyledTextField from '@shared/components/core/field/StyledTextField';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { useTranslation } from 'react-i18next';

function TalkBackField({ value, onChange, disabled }: IControlFieldProps) {
    const { t } = useTranslation();
    return (
        <FieldContainer>
            <StyledTextField
                fullWidth
                disabled={disabled}
                type="text"
                value={value}
                label={t('common:talkback.title')}
                placeholder={t('common:talkback.question')}
                onChange={(e) => onChange(e.target.value)}
            />
        </FieldContainer>
    );
}

export default TalkBackField;
